import { render, staticRenderFns } from "./register-success.vue?vue&type=template&id=69f40326&scoped=true&"
import script from "./register-success.vue?vue&type=script&lang=ts&"
export * from "./register-success.vue?vue&type=script&lang=ts&"
import style0 from "./register-success.vue?vue&type=style&index=0&id=69f40326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f40326",
  null
  
)

export default component.exports